window.Auth = {
	submitReg: function ($form) {
		let route = $form.attr('action');
		let params = $form.serializeArray();

		$btn = $form.find('[type=submit]');
		$btn.text($btn.data('loading')).attr('disabled', 'disabled');

		$.ajax({
			type: "POST",
			url: route,
			data: $form.serializeArray(),
			success: function (data) {
				Auth.callback($form, data);
			},
			error: function (xhr) {
				Auth.callback($form, $.parseJSON(xhr.responseText));
			},
		});

		return false;
	},

	submitAuth: function ($form) {
		let route = $form.attr('action');

		$btn = $form.find('[type=submit]');
		$btn.text($btn.data('loading')).attr('disabled', 'disabled');

		$.ajax({
			type: "POST",
			url: route,
			data: $form.serializeArray(),
			success: function (data) {
				Auth.callback($form, data);
			},
			error: function (xhr) {
				Auth.callback($form, $.parseJSON(xhr.responseText));
			},
		});

		return false;
	},

	submitForgot: function ($form) {
		let route = $form.attr('action');

		$btn = $form.find('[type=submit]');
		$btn.text($btn.data('loading')).attr('disabled', 'disabled');

		$.ajax({
			type: "POST",
			url: route,
			data: $form.serializeArray(),
			success: function (data) {
				Auth.callback($form, data);
			},
			error: function (xhr) {
				Auth.callback($form, $.parseJSON(xhr.responseText));
			},
		});

		return false;
	},

	getError: function (data) {
		if (data.msg) {
			return data.msg;
		}

		for (let i in data.errors) {
			return data.errors[i][0];
		}
	},
	showMsg: function ($form, text, type) {
		$form.find('.msg').slideUp();

		if (type == 1) {
			$form.find('.msg.success').text(text).slideDown();
		} else if (type == 0) {
			$form.find('.msg.error').text(text).slideDown();
		}
	},

	callback: function ($form, data) {
		if (data.errors || (data.error && data.msg)) {
			$btn.text($btn.data('text')).removeAttr('disabled');
			Auth.showMsg($form, Auth.getError(data), 0);
		}

		if (!data.errors && !data.error && data.msg) {
			$btn.text($btn.data('text')).removeAttr('disabled');
			Auth.showMsg($form, Auth.getError(data), 1);
		}

		if (data.redirect_to) {
			location.href = data.redirect_to;
		}
	}
};

$("#form-reg").submit(function () {
	Auth.submitReg($(this));
	return false;
});

$("#form-auth").submit(function () {
	Auth.submitAuth($(this));
	return false;
});

$("#form-forgot").submit(function () {
	Auth.submitForgot($(this));
	return false;
});

$(document).on('click', '[data-target="#modalUserAuth"]', function () {
	var redirect_to = $(this).data('redirect_to');
	if (redirect_to) {
		var $modal = $("#modalUserAuth");
		$modal.find('form').append('<input type="hidden" name="redirect_to" value="' + redirect_to + '" />');
		$modal.modal('show');

		return false;
	}
});